import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./main.css";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import secureLocalStorage from "react-secure-storage";
import NavBar from "../../../components/organisms/Navbar";
import Header from "../../../components/organisms/Header";
import { fetchSettingsThunk } from "../../../store/thunks/settingsThunk";
import { useDispatch } from "react-redux";

export default function Main({
  children = null,
  key_elem = "1",
  nameLink = "",
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const pageSegments = location.pathname.split("/");
  const mainPath = pageSegments?.[1];
  const subPath = pageSegments?.[2];
  const thirdSegment = pageSegments?.[3];
  const isTargetPath =
    ["auditForms", "audits", "deleted-audits"].includes(mainPath) ||
    (subPath === "preview" && thirdSegment);
  const auditFormEditPage = mainPath === "auditForms" && thirdSegment;
  const clientEscalationDetailPage = mainPath === "escalations" && thirdSegment;

  const condition = isTargetPath && subPath && !auditFormEditPage;

  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  {
    /* Get Logo and Logo's title*/
  }
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const logoInfo = async (page = 1, pageSize = 1) => {
    try {
      setGlobalState((prev) => ({ ...prev, list: [] }));
      const payload = { page, pageSize };

      const response = await dispatch(fetchSettingsThunk(payload)).unwrap();
      const parsedResponse =
        typeof response === "string" ? JSON.parse(response) : response;

      const { settings } = parsedResponse;
      if (settings?.length > 0) {
        setGlobalState((prev) => ({
          ...prev,
          logo: settings[0].logo,
          logoTitle: settings[0].title,
        }));
      }
    } catch (error) {
      console.error("Error fetching settings", error);
    }
  };

  useEffect(() => {
    logoInfo();
  }, []);

  return (
    <div>
      {globalState?.logo && globalState?.logoTitle && (
        <>
          <div className="main-layout">
            <NavBar globalStte={globalState} />

            <div
              className={
                condition || clientEscalationDetailPage
                  ? "right-side detailPage"
                  : "right-side"
              }
            >
              <Header nameLink={nameLink} />
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
